import { Component, OnInit} from '@angular/core';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'app-update-admin-lead-details',
  templateUrl: './update-admin-lead-details.component.html',
  styleUrls: ['./update-admin-lead-details.component.css']
})
export class UpdateAdminLeadDetailsComponent implements OnInit {

  leadDetailsForm: FormGroup;
  loading: boolean = false;dataLoaded: boolean = false; submitted: boolean = false; lead_id: string;
  lead_sources = []; lead_sources_copy = []; bridge_number_lists = []; bridge_number_lists_copy = [];

  constructor(private formBuilder: FormBuilder, private leadapi: LeadsService, private sharedapi: SharedService, private route: ActivatedRoute) {
    this.leadDetailsForm = this.formBuilder.group({
      'lead_source': [null, Validators.required],
      'bridgeno': [null],
      'keywords': [null]
    });
  }

  ngOnInit(): void {
    this.lead_id = this.route.snapshot.paramMap.get("lead_id");
    this.getLeadSources();
    this.getBridgeNumberLists();
    this.getLeadDetails();
  }


  get f() { return this.leadDetailsForm.controls; }

  async saveLeadDetails() {
    this.submitted = true;
    this.loading = true;
    if (this.leadDetailsForm.invalid) {
      this.loading = false;
      return;
    }
    this.leadDetailsForm.value.id = parseInt(this.lead_id);
    await this.leadapi.saveAdminUpdateLeadDetails(this.leadDetailsForm.value).subscribe((data: any) => {
      this.submitted = false;
      this.loading = false;
      if (data.status) {
        this.sharedapi.presentToast(data.msg);
      }
      else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }

  async getLeadSources() {
    this.leadapi.getLeadSources().subscribe((data: any) => {
      if (data.status) {
        this.lead_sources = data.data;
        this.lead_sources_copy = this.lead_sources;
      } else {
        this.lead_sources = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }
  async getBridgeNumberLists() {
    this.leadapi.getBridgeNumberLists().subscribe((data: any) => {
      if (data.status) {
        this.bridge_number_lists = data.data;
        this.bridge_number_lists_copy = this.bridge_number_lists;
      } else {
        this.bridge_number_lists = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  setSearchValue(type) {
    if (type == 'lead_source') {
      $("#leadsourceSearch").val('');
      $("#leadsourceSearch").focus();
      this.lead_sources = this.lead_sources_copy;
    } else if (type == 'bridgeno') {
      $("#bridgenoSearch").val('');
      $("#bridgenoSearch").focus();
      this.bridge_number_lists = this.bridge_number_lists_copy;
    }
  }

  searchOnSelect(searchtText: string, type) {
    if (type == 'lead_source') {
      this.lead_sources = this.sharedapi.searchData(searchtText, this.lead_sources_copy, "source_name");
    } else if (type == 'bridgeno') {
      this.bridge_number_lists = this.sharedapi.searchData(searchtText, this.bridge_number_lists_copy, "bridge_number");
    }
  }


  async getLeadDetails() {
    this.dataLoaded = false;
    await this.leadapi.getLeadDetail(this.lead_id).subscribe((data: any) => {
      if (data.status) {
        console.log(data.data.bridge_no);
        this.dataLoaded = true;
        this.leadDetailsForm.setValue({
          'lead_source': data.data.lead_source,
          'bridgeno': String(data.data.bridge_no),
          'keywords': data.data.keywords,
        });

      } else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }




}
